import React, { FC } from 'react'
import { HorizontalLine } from 'components/Utility'
import { OrderTime, OrderType } from 'types/checkout'
import { OrderCardHeader, DeliveryOrderCardBody, OrderCardFooter, Card } from 'components/Card'
import { sumOrderQuantity } from 'lib/order'
import { UserType } from 'types/user'
import { StoreShippingType } from 'types/storeShipping'
import { StoreType } from 'types/store'

type Props = {
  isSearch?: boolean
  manufacturerNames?: string
  order: OrderType
  orderTime: OrderTime
  store?: StoreType
  storeShipping: StoreShippingType
  user?: UserType
}

const DeliveryOrderCard: FC<Props> = (props) => {
  const { isSearch, manufacturerNames, order, orderTime, store, storeShipping, user } = props
  return (
    <Card>
      <OrderCardHeader
        basketNumber={storeShipping.shipping_number}
        manufacturerNames={manufacturerNames}
        orderTime={orderTime}
        store={store}
        tel={user?.tel || ''}
        username={user?.name || ''}
        userId={user?.user_id || ''}
      />
      <HorizontalLine verticalMargin={16} />
      <DeliveryOrderCardBody isSearch={isSearch} order={order} storeShipping={storeShipping} />
      <HorizontalLine verticalMargin={16} />
      <OrderCardFooter amount={order.amount} quantity={sumOrderQuantity([order])} />
    </Card>
  )
}

export default DeliveryOrderCard
